export default __webpack_public_path__ + "static/media/IMG_0092.411f5299.jpg";